import { Injectable } from '@angular/core';
import {HttpClient,HttpHeaders} from "@angular/common/http";
import {environment} from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {

  constructor(private httpClient: HttpClient) { }

  getURL(){
    return this.httpClient.get<any>(`${environment.apiUser}/feedback/url/digital/banking/HOSTNAME_BDA`);
  }
  sendFeedback(jwtFeedBack : String , feedbackJson: any){
    let headers = new HttpHeaders();
    headers = headers.set('Authorization-Feedback', jwtFeedBack+"");
    return this.httpClient.post<any>(`${environment.apiUser}/feedback/send`,feedbackJson,{headers : headers});
  }
}
